<script>
    import _ from 'lodash'

    export default {
        name: 'PasswordInput',
        props: {
            minlength: {
                type: Number,
                default: 12
            },
            upper: {
                type: Boolean,
                default: true
            },
            number: {
                type: Boolean,
                default: true
            },
            special: {
                type: Boolean,
                default: true
            }
        },
        data: () => ({
            password: [],
            valids: [],
            hasAlphaLower: false,
            hasAlphaUpper: false,
            hasNumber: false,
            hasSpecial: false,
            isValid: false,
            showInput: false
        }),
        computed: {
            pwHint() {
                let hint = ''
                let intro = this.$vuetify.lang.t('$vuetify.register.pwHintIntro')
                intro = intro.replace(/ 8 /, ` ${this.minlength} `)
                hint = intro + ' '
                hint += this.$vuetify.lang.t('$vuetify.register.pwHintAlphaLower') + ', '
                if (this.upper) hint += this.$vuetify.lang.t('$vuetify.register.pwHintAlphaUpper') + ', '
                if (this.number) hint += this.$vuetify.lang.t('$vuetify.register.pwHintNumber') + ', '
                if (this.special) hint += this.$vuetify.lang.t('$vuetify.register.pwHintSpecial')
                hint += ' ' + this.$vuetify.lang.t('$vuetify.register.pwHintEnd')
                return hint
            }
        },

        watch: {
        },

        mounted() {
            this.$nextTick(() => {
                this.password = new Array(this.minlength).fill('')
                this.valids = new Array(this.minlength).fill(true)
            })
        },

        methods: {
            onInputChar(idx, event) {
                let char = _.trim(event.target.value)
                if (char.length > 1 && event.inputType === 'insertFromPaste') {
                    const after = char.substring(1)
                    for (let i = 0; i < after.length; i++) {
                        this.setChar(i + idx + 1, after[i])
                    }
                    char = char.charAt(0)
                }
                this.setChar(idx, char)
                if (this.isValid && event.inputType !== 'deleteContentBackward') {
                    const nextCharEl = this.$el.querySelector(`[name="char${idx + 1}"]`)
                    nextCharEl?.focus()
                }
            },
            setChar(idx, char) {
                this.$set(this.password, idx - 1, char)
                this.$set(this.valids, idx - 1, true)
                this.isValid = true
                if (/[a-z]/.test(char)) this.hasAlphaLower = true
                else if (/[A-Z]/.test(char)) this.hasAlphaUpper = true
                else if (/[0-9]/.test(char)) this.hasNumber = true
                else if (/[+%]/.test(char)) {
                    this.isValid = false
                    this.$set(this.valids, idx - 1, false)
                    console.log('NOT VALID', idx, char)
                } else {
                    this.hasSpecial = true
                }
            }
        }
    }
</script>

<template>
    <div class="v-password-input">
        <div class="v-password-input__hint">
            <div>{{ pwHint }}</div>
        </div>
        <div class="v-password-input__chars">
            <div class="v-password-input__actions">
                <VBtn icon @click="showInput = !showInput">
                    <VIcon>{{ !showInput ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}</VIcon>
                </VBtn>
            </div>
            <div v-for="c in minlength" :key="c"
                class="char"
                :class="{ 'is-invalid': !valids[c - 1] }">
                <input
                    :type="showInput ? 'text' : 'password'"
                    :name="'char' + c"
                    size="1"
                    :placeholder="c"
                    :value="password[c - 1]"
                    @input="onInputChar(c, $event)">
            </div>
        </div>
        <div class="v-password-input__legend">
            <div class="requirement" :class="{ 'is--done': hasAlphaLower }">
                <VIcon>{{ !hasAlphaLower ? 'mdi-alphabetical' : 'mdi-alphabetical-off' }}</VIcon>
                <span>Klein</span>
            </div>
            <div class="requirement" :class="{ 'is--done': hasAlphaUpper }">
                <VIcon>{{ !hasAlphaUpper ? 'mdi-alphabetical-variant' : 'mdi-alphabetical-variant-off' }}</VIcon>
                <span>Groß</span>
            </div>
            <div class="requirement" :class="{ 'is--done': hasNumber }">
                <VIcon>{{ !hasNumber ? 'mdi-numeric': 'mdi-numeric-off' }}</VIcon>
                <span>Nummer</span>
            </div>
            <div class="requirement" :class="{ 'is--done': hasSpecial }">
                <VIcon>{{ !hasSpecial ? 'mdi-keyboard-outline' : 'mdi-keyboard-off-outline' }}</VIcon>
                <span>Sonderzeichen</span>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .v-password-input {
        margin: 16px 0;
    }
    .v-password-input__actions {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-evenly;
        gap: 8px;
    }
    .v-password-input__chars {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        gap: 8px;
        padding: 8px;
    }
    .v-password-input__hint {
        display: flex;
        justify-content: center;
        padding: 0 32px;
    }
    .v-password-input__legend {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-evenly;
        margin-bottom: 16px;
    }
    .v-password-input .char {
        width: 36px;
        height: 48px;
        border: 2px solid black;
        border-radius: 5px;
        box-sizing: content-box;
        &.is-invalid {
            border-color: red;
        }
    }
    .v-password-input .char input {
        line-height: 48px;
        font-size: 26px;
        font-weight: 700;
        text-align: center;
        outline: none;
    }
    .v-password-input .char input::-webkit-input-placeholder {
        color: rgba(232, 232, 232);
    }
    .requirement {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-evenly;
        gap: 8px;
        &.is--done {
            color: green;
            .v-icon {
                color: green;
            }
        }
    }
</style>
